import { Injectable, signal } from '@angular/core';
import {
  FileUploadTexts,
  GridTableTexts,
  NotFoundPageTexts,
} from 'declarabid-library';

@Injectable({
  providedIn: 'root',
})
export class LibraryTextsTranslationsService {
  readonly gridTableTexts = signal<Record<GridTableTexts, string>>({
    CURRENT_PAGE_REPORT: $localize`Mostrando {last} de {totalRecords} resultados`,
    CURRENT_PAGE_REPORT_ALTERNATIVE: $localize`Mostrando {first} a {last} de {totalRecords} elementos`,
    CURRENT_PAGE_REPORT_ELEMENT: $localize`Mostrando {last} de {totalRecords} elementos`,
    TOTAL: $localize`Total`,
    SELECTED: $localize`seleccionados`,
    EXPORT_EXCEL: $localize`Exportar excel`,
    RESULT: $localize`Resultado`,
    ATTACHMENTS: $localize`Adjuntos`,
    MESSAGES: $localize`Mensajes`,
    EXPIRATION_ALERTS: $localize`Alertas de vencimiento`,
    TIME_EXTENSIONS: $localize`Extensiones de tiempo`,
    ASSIGNED_REVIEWER: $localize`Revisor Asignado`,
    CONFLICT_OF_INTERESTS: $localize`Conflicto de intereses`,
    INTEREST_TRACKING: $localize`Seguimiento de interés`,
    APPLICANT: $localize`Solicitante`,
    REVIEWER: $localize`Revisor`,
    CANCEL: $localize`Cancelar`,
    EDIT: $localize`Editar`,
    DELETE: $localize`Eliminar`,
    EXTEND_TIME: $localize`Extender tiempo`,
    VIEW_PDF: $localize`Ver PDF`,
    IN_PROGRESS: $localize`En progreso`,
    REVIEW_IN_PROGRESS: $localize`Revisión en curso`,
    CLOSED: $localize`Cerrado`,
    REVIEW_NOT_STARTED: $localize`Revisión no iniciada`,
    NOT_OPENED: $localize`No abierto`,
    SENT: $localize`Enviada`,
    CLOSED_STATUS: $localize`Cerrada`,
    RETURNED_TO_APPLICANT: $localize`Reenviado al solicitante`,
    ADMINISTRATIVE_CLOSURE: $localize`Cierre administrativo`,
    RETURNED_TO_APPLICANT_ALT: $localize`Devuelto al declarante`,
    RESENT_BY_DECLARANT: $localize`Reenviado por el declarante`,
    TRANSFERRED_TO_ADMIN: $localize`Transferido al administrador`,
    TRANSFERRED: $localize`Transferido`,
    DRAFT: $localize`Borrador`,
    ACTIVE: $localize`Activo`,
    ACTIVE_WITH_EXTENSION: $localize`Activo con extensión`,
    FINISHED: $localize`Finalizado`,
    ENABLED: $localize`Habilitado`,
    DISABLED: $localize`Inhabilitado`,
    CONFIRM_DELETE_HEADER: $localize`¿Estás seguro que quieres eliminar esta asignación?`,
    CONFIRM_DELETE_MESSAGE: $localize`Por motivos de seguridad, te solicitamos que confirmes la eliminación de esta asignación.`,
    CONFIRM_DELETE_WARNING: $localize`Es importante que tengas en cuenta que este proceso es permanente y no puede revertirse.`,
    DELETE_ASSIGNMENT: $localize`Eliminar asignación`,
    DO_NOT_DELETE: $localize`No eliminar`,
    DELETED: $localize`Eliminado`,
    ASSIGNMENT_DELETED: $localize`La asignación ha sido eliminada correctamente`,
    CANCELLED: $localize`Cancelado`,
    DELETION_CANCELLED: $localize`La eliminación ha sido cancelada`,
    CONFIRM_CHANGE_DATE_HEADER: $localize`¿Estas seguro que quieres cambiar la fecha limite esta asignación?`,
    CONFIRM_CHANGE_DATE_MESSAGE: $localize`Recuerda que al momento de cambiar la fecha de finalización de la asignación...`,
    CHANGE_DATE_LIMIT: $localize`Cambiar fecha limite`,
    ACCESS_NOT_AVAILABLE: $localize`Acceso no disponible`,
    ASSIGNMENT_NOT_AVAILABLE: $localize`La asignación aún no está disponible, Faltan {days} día(s) para que puedas acceder.`,
    DECLARANT: $localize`Declarante`,
    DATE_CHANGED: $localize`Fecha cambiada`,
    DATE_CHANGED_SUCCESS: $localize`La fecha ha sido cambiada correctamente`,
    DATE_NOT_CHANGED: $localize`Fecha no cambiada`,
    DATE_NOT_CHANGED_ERROR: $localize`La fecha no ha sido cambiada`,
    VIEW: $localize`Visualizar`,
    COPY_STATUS_COMPLETED: $localize`Copiado`,
    COPY_STATUS_PROCESSING: $localize`En proceso...`,
    COPY_STATUS_FAILED_RETRY: $localize`Fallido - Reintentar`,
    COPY_STATUS_PENDING: $localize`Pendiente`,
    COPY_STATUS_NOT_APPLICABLE: $localize`No Aplica`,
    RETRY_COPY: $localize`Reintentar copia`,
    VIEW_ACTIONS: $localize`Ver acciones`,
  });

  readonly fileUploadTexts = signal<Record<FileUploadTexts, string>>({
    SELECT_FILES: $localize`Seleccionar archivos`,
    DRAG_AND_DROP_FILES: $localize`Arrastrar y soltar archivos o Examinar`,
    ACCEPTED_FORMATS: $localize`Formatos admitidos:`,
    INVALID_FILE_TYPE: $localize`Tipo de archivo no válido`,
  });

  readonly notFoundPageTexts = signal<Record<NotFoundPageTexts, string>>({
    PAGE_NOT_FOUND: $localize`Pagina no encontrada`,
    PAGE_NOT_FOUND_MESSAGE: $localize`¿Estas perdido? puedes volver al`,
    PAGE_NOT_FOUND_LINK: $localize`Inicio`,
    PAGE_NOT_FOUND_LINK_ADMIN: $localize`O contactar al administrador`,
  });
}
